import React, { Component } from 'react';
import { Pagination, Panel, Form, FormField, Tooltip, Messager, Label, NumberBox, DataGrid, Dialog, DateBox, GridColumn, LinkButton, ComboBox, TextBox, MaskedBox, Button } from 'rc-easyui';
import { API_URL } from '../../../constants';
import { getAccessToken, getCookie } from '../../../helpers/cookieHelper';
import axios from 'axios';
import { getUserId } from '../../../helpers/AuthHelper';
import { isEmpty } from '../../../helpers/Common';
import { getFormattedDate } from '../../../helpers';

export default class ViewTimesheetSystem extends Component {
    constructor(props) {
        super(props)

        this.state = {
            statusData: [{ value: "Draft", text: "Draft" }, { value: "Submitted", text: "Submitted" }, { value: "Approved", text: "Approved" }, { value: "Rejected", text: "Rejected" }],
            pageArray: [],
            StatusList: [],
            pageOptions: {},

            // rules: {
            //     projectId: ['required'],
            //     subprojectId: ['required'],
            //     timeSpent: ['required'],
            //     description: ['required'],

            // },
            editingRow: null,
            errors: {},
            model: {},
            title: '',
            closed: true,
            closed2: true,
            editTimesheet: {
                id: '',
                projectId: "",
                subprojectId: "",
                description: "",
                enabled: true,
                userId: "",
                timeSpent: "",
                status: "",
                comments: " ",
                dateBs: new Date()
            },

            searchparam: {
                fromdate: new Date(),
                todate: new Date(),
                projectId: "",
                subprojectId: "",
                status: "",
                comments: "",
                enabled: true,
            },
            isLoading: false,
            pageOptions: {
                pageOptions: {
                    layout: [
                        "list",
                        "sep",
                        "first",
                        "prev",
                        "next",
                        "last",
                        "sep",
                        "refresh",
                        "sep",
                        "manual",
                        "info",
                    ],
                },
            },
        }
    }



    componentDidMount = async () => {
        const date = new Date();
        let fullYear = date.getFullYear();
        let fullMonth = date.getMonth()
        let fullDay = date.getDate()
        let formattedDate = fullYear + '-' + (fullMonth + 1) + '-' + fullDay
        const today = formattedDate;

        const timestamp = date.getTime();
        const sevenDaysTimeStamp = timestamp - 7 * 24 * 60 * 60 * 1000;
        const sevenDaysDate = new Date(sevenDaysTimeStamp);
        let sfullYear = sevenDaysDate.getFullYear();
        let sfullMonth = sevenDaysDate.getMonth()
        let sfullDay = sevenDaysDate.getDate()
        let formattedFromDate = sfullYear + '-' + (sfullMonth + 1) + '-' + sfullDay


        this.setState({
            pageOptions: {
                loading: true,
                pageOptions: {
                    pageNumber: 1,
                    pageSize: 100,
                    pagePosition: 'bottom',
                    pageList: [10, 20, 30, 40, 50, 60, 70, 80],
                    layout: [
                        'list',
                        'sep',
                        'first',
                        'prev',
                        'next',
                        'last',
                        'sep',
                        'refresh',
                        'sep',
                        'manual',
                        'info',
                    ],
                },
            },
            searchparam: {
                fromdate: new Date(formattedFromDate),
                todate: new Date(today),
                projectId: "",
                subprojectId: "",
                status: "",
                comments: "",
                enabled: true,
            },
            user: []

        },
            () => {
                // this.getData()
                this.getUsers()
            })
    }

    getUsers = async () => {
        let erp_access_token = getCookie('access_token')
        let erp_token_type = getCookie('token_type')
        let headerConfig = {
            headers: {
                authorization: erp_token_type + ' ' + erp_access_token,
                'Content-Type': 'application/json',
            },
        }
        if (erp_access_token != null) {
            this.setState({
                isLoading: true,
            })
            // let url = API_URL + 'api/fetchallprojectInfo';
            let url = `${API_URL}api/users`

            await axios.get(url, headerConfig)
                .then((response) => {

                    if (response.status === 200) {
                        var dataObject = response.data
                        this.props.setUserId(dataObject)
                        this.setState({
                            user: dataObject,
                            isLoading: false
                        })
                        this.getData()

                    } else {
                        this.setState({
                            user: [],
                        })
                    }
                })
                .catch((error) => {
                    this.setState({
                        user: [],
                    })
                    // alert ("Internal server error");
                    let response = error['response']
                    if (response !== undefined) {
                        this.messager.alert({
                            title: 'Error',
                            icon: 'error',
                            reload: false,
                            msg: response.data.message
                        })//Backend Validation Error i.e. 403
                    } else {
                        this.messager.alert({
                            title: 'Error',
                            icon: 'error',
                            msg: 'Internal Server Error',
                            reload: false,
                        })// Caused due to syntax error in front end
                    }
                })


        } else {
            const resp = await getAccessToken()
            if (resp) {
                this.getUsers()
            }
        }
    }


    getData = async () => {
        const { pageNumber, pageSize } = this.state.pageOptions.pageOptions;
        const { fromdate, todate, projectId, subprojectId, status, enabled, comments } = this.state.searchparam;

        let userId = this.props.userId;
        var access_token = getCookie("access_token");
        var token_type = getCookie("token_type");
        let headerConfig = {
            headers: {
                authorization: token_type + " " + access_token,
                "Content-Type": "application/json",
            }
        }
        let enable = true;
        if (enabled) {
            enable = 1
        } else {
            enable = 0
        }
        var url = `${API_URL}api/viewmytimesheetsystemwithpagination?fromdate=${getFormattedDate(fromdate)}&todate=${getFormattedDate(todate)}&projectid=${projectId}&subprojectid=${subprojectId}&userid=${userId}&status=${status}&comments=${comments}&enabled=${enable}&page=${pageNumber}&rows=${pageSize}`;
        // var url = `http://localhost:9191/api/getticketwithpagination?username=a&priority=m&expectedcompletiondatead=2020-09-11&status=n&projectname=e&version=v&enabled=1&rows=4&page=1`
        this.setState({
            pageOptions: {
                pageOptions: { ...this.state.pageOptions.pageOptions },
                loading: true,
            },
        });
        if (access_token != null) {
            await axios.get(url, headerConfig)
                .then((response) => {
                    if (response.status === 200) {
                        let pageArr = response.data.rows.timesheetSystemlist;
                        // pageArr=pageArr.map((item)=>{
                        //    if (item.enabled){
                        //        item.enabled="active"
                        //            }else{
                        //        item.enabled="inactive"
                        //                    }
                        //        return item;
                        //                   })
                        pageArr.map(data => {
                            this.props.projectList.map(projectlist => {
                                if (data.projectId === projectlist.id) {
                                    data.projectId = projectlist.name
                                }
                            })
                            this.props.subprojectList.map(subprojectlist => {
                                if (data.subprojectId === subprojectlist.id) {
                                    data.subprojectId = subprojectlist.name
                                }
                            })
                            let newdate = new Date(data.dateAd)
                            let fullYear = newdate.getFullYear()
                            let fullMonth = newdate.getMonth()
                            let fullDay = newdate.getDate()
                            newdate = fullYear + '-' + fullMonth + '-' + fullDay
                            data.dateAd = newdate
                        })
                        let total = response.data.total;
                        this.setState({
                            pageArray: pageArr,
                            pageOptions: {
                                pageOptions: {
                                    pageSize: 20,
                                    pageList: [20, 50, 30, 100, total].sort(
                                        function (a, b) {
                                            return a - b;
                                        }),
                                    total: total,
                                    ...this.state.pageOptions.pageOptions,
                                },
                                loading: false,
                            },
                        }, () => { this.props.viewData(this.state.pageArray) });

                    } else {
                        this.setState({
                            pageOptions: {
                                pageOptions: { ...this.state.pageOptions.pageOptions },
                                loading: false,
                            }
                        })
                    }
                })
                .catch((error) => {
                    this.setState({
                        pageOptions: {
                            pageOptions: { ...this.state.pageOptions.pageOptions },
                            loading: false,
                        },
                    });
                });
        } else {
            const resp = await getAccessToken();
            if (resp) {
                this.getData();
            }
        }
    }

    onPageChange = (event) => {

        this.setState(
            {
                pageOptions: {
                    pageOptions: { ...this.state.pageOptions.pageOptions, ...event },
                    loading: true,
                },
            },
            function () {
                this.getData();
            }
        );

    }

    searchFieldOnChange = (name, e) => {
        let searchparam = Object.assign({}, this.state.searchparam)

        searchparam[name] = e

        this.setState({ searchparam: searchparam })
    }

    onPageChange = (event) => {

        this.setState(
            {
                pageOptions: {
                    pageOptions: { ...this.state.pageOptions.pageOptions, ...event },
                    loading: true,
                },
            },
            function () {
                this.getData();
            }
        );

    }

    handleInputChange = (name, value) => {
        let temp = Object.assign({}, this.state.editTimesheet)
        temp[name] = value
        this.setState({
            editTimesheet: temp
        })
    }

    draftRow = async () => {
        const { editTimesheet } = this.state
        let token = getCookie("access_token");
        let tokenType = getCookie("token_type");
        let form = {
            id: editTimesheet.id,
            projectId: editTimesheet.projectId,
            subprojectId: editTimesheet.subprojectId,
            description: editTimesheet.description,
            enabled: true,
            userId: this.props.userId,
            timeSpent: editTimesheet.timeSpent + "H",
            status: "Draft",
            comments: " ",
            dateBs: getFormattedDate(editTimesheet.dateBs)
        }
        this.setState({
            closed: true
        })

        let apiUrl = `${API_URL}api/savetimesheet`;
        let headersConfig = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `${tokenType} ${token}`,
            },
        };

        if (token != null) {
            //Access Token Available
            this.setState({
                isLoading: true,
            });
            axios
                .put(apiUrl, form, headersConfig)
                .then((response) => {
                    if (response.status === 200) {
                        this.props.clearSelected()
                        this.getData();
                        this.setState({
                            isLoading: false,
                        });
                        if (response.data.status) {
                            this.messager.alert({
                                title: "Success",
                                msg: 'Data updated in draft successfully',
                                icon: "info",
                                reload: false,
                                buttons: [
                                    {
                                        text: "ok",
                                        onClick: () => {
                                            window.location.reload();
                                        },
                                    },
                                ],
                            }); // script detail  Saved Successfully ie. 200
                            // autoDissaperAction();
                        } else {
                            this.messager.alert({
                                title: "Error",
                                msg: response.data.message,
                            });
                        }
                        // this.props.formClear();
                    } else {
                        this.messager.alert({
                            title: "Error",
                            msg: "Uncaught Error",
                            reload: false,
                        });
                    }
                })
                .catch((error) => {
                    this.setState({
                        isLoading: false,
                    });
                    this.messager.alert({
                        title: "Error",
                        msg: "Internal Server Error",
                        reload: false,
                    });
                    var response = error["response"];
                    if (response !== undefined) {
                        if (response.status === 400) {
                            var message = "";
                            response.data.errors.forEach((row, i) => {
                                message +=
                                    "<p style='margin-bottom:3px;'>" +
                                    row.field.toUpperCase() +
                                    " " +
                                    row.defaultMessage +
                                    "</p>";
                            });
                            this.messager.alert({
                                title: "Error",
                                msg: message,
                                reload: false,
                            }); // Backend Validation Error ie.400
                        } else {
                            this.messager.alert({
                                title: "Error",
                                msg: "UnCaught Error",
                                reload: false,
                            }); // Uncaught Backend Error ie.500 eyc.
                        }
                    } else {
                        this.messager.alert({
                            title: "Error",
                            msg: "Internal Server Error",
                            reload: false,
                        }); // Caused due to syntax error in front end
                    }
                });
        } else {
            //Access Token Expired.
            //Generate new Access Token using Refresh Token.
            const resp = await getAccessToken();
            if (resp) {
                this.draftRow();
            }
        }

    }

    submitRow = async () => {
        const { editTimesheet } = this.state
        let token = getCookie("access_token");
        let tokenType = getCookie("token_type");
        let form = {
            id: editTimesheet.id,
            projectId: editTimesheet.projectId,
            subprojectId: editTimesheet.subprojectId,
            description: editTimesheet.description,
            enabled: true,
            userId: this.props.userId,
            timeSpent: editTimesheet.timeSpent + "H",
            status: "Submitted",
            comments: " ",
            dateBs: getFormattedDate(editTimesheet.dateBs)
        }
        this.setState({
            closed2: true,
            closed: true
        })

        // console.log(form)
        let apiUrl = `${API_URL}api/savetimesheet`;
        let headersConfig = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `${tokenType} ${token}`,
            },
        };

        if (token != null) {
            //Access Token Available
            this.setState({
                isLoading: true,
            });
            axios
                .put(apiUrl, form, headersConfig)
                .then((response) => {
                    if (response.status === 200) {
                        this.props.clearSelected()
                        this.getData();
                        this.setState({
                            isLoading: false,
                        });
                        if (response.data.status) {
                            this.messager.alert({
                                title: "Success",
                                msg: response.data.message,
                                icon: "info",
                                reload: false,
                                buttons: [
                                    {
                                        text: "ok",
                                        onClick: () => {
                                            window.location.reload();
                                        },
                                    },
                                ],
                            }); // script detail  Saved Successfully ie. 200
                            // autoDissaperAction();
                        } else {
                            this.messager.alert({
                                title: "Error",
                                msg: response.data.message,
                            });
                        }
                        // this.props.formClear();
                    } else {
                        this.messager.alert({
                            title: "Error",
                            msg: "Uncaught Error",
                            reload: false,
                        });
                    }
                })
                .catch((error) => {
                    this.setState({
                        isLoading: false,
                    });
                    this.messager.alert({
                        title: "Error",
                        msg: "Internal Server Error",
                        reload: false,
                    });
                    var response = error["response"];
                    if (response !== undefined) {
                        if (response.status === 400) {
                            var message = "";
                            response.data.errors.forEach((row, i) => {
                                message +=
                                    "<p style='margin-bottom:3px;'>" +
                                    row.field.toUpperCase() +
                                    " " +
                                    row.defaultMessage +
                                    "</p>";
                            });
                            this.messager.alert({
                                title: "Error",
                                msg: message,
                                reload: false,
                            }); // Backend Validation Error ie.400
                        } else {
                            this.messager.alert({
                                title: "Error",
                                msg: "UnCaught Error",
                                reload: false,
                            }); // Uncaught Backend Error ie.500 eyc.
                        }
                    } else {
                        this.messager.alert({
                            title: "Error",
                            msg: "Internal Server Error",
                            reload: false,
                        }); // Caused due to syntax error in front end
                    }
                });
        } else {
            //Access Token Expired.
            //Generate new Access Token using Refresh Token.
            const resp = await getAccessToken();
            if (resp) {
                this.draftRow();
            }
        }
    }

    getError(name) {
        const { errors } = this.state;
        if (!errors) {
            return null;
        }
        return errors[name] && errors[name].length
            ? errors[name][0]
            : null;
    }

    onSubmitClick = () => {
        this.setState({
            closed2: false
        })
    }


    renderDialog() {
        const { selected } = this.props
        const row = this.state.model;
        const { title, closed, rules } = this.state;
        return (
            <Dialog modal title="Edit" closed={closed} onClose={() => this.setState({ closed: true })}>
                <div className="f-full" style={{ padding: '20px 50px' }}>
                    <Form className="f-full"
                        ref={ref => this.form = ref}
                        model={this.state.editTimesheet}
                        rules={rules}
                        onValidate={(errors) => this.setState({ errors: errors })}
                        onChange={this.handleInputChange}
                    >
                        <div style={{ marginBottom: 10 }}>
                            <Label>Date:</Label>
                            <DateBox
                                name="dateBs"
                                style={{ width: "220px" }}
                                format="yyyy-MM-dd"
                                value={this.state.editTimesheet.dateBs}
                            ></DateBox>
                        </div>
                        <div style={{ marginBottom: 10 }}>
                            <Label htmlFor="projectList">Project:</Label>
                            <ComboBox
                                inputId="projectId"
                                name="projectId"
                                style={{ width: "220px" }}
                                data={this.props.projectList}
                                value={this.state.editTimesheet.projectId}
                                valueField="id"
                                textField="name"
                            >
                            </ComboBox>
                            <div className="error">{this.getError('projectId')}</div>
                        </div>
                        <div style={{ marginBottom: 10 }}>
                            <Label htmlFor="subprojectList">Sub-Project:</Label>
                            <ComboBox
                                inputId="subprojectId"
                                name="subprojectId"
                                style={{ width: "220px" }}
                                data={this.props.subprojectList}
                                value={this.state.editTimesheet.subprojectId}
                                valueField="id"
                                textField="name"
                            >
                            </ComboBox>
                            <div className="error">{this.getError('subprojectId')}</div>
                        </div>
                        <div style={{ marginBottom: 10 }}>
                            <Label htmlFor="description">Description:</Label>
                            <TextBox style={{ width: "220px" }}
                                inputId="description"
                                name="description"
                                value={this.state.editTimesheet.description}
                            ></TextBox>
                            <div className="error">{this.getError('description')}</div>
                        </div>
                        <div style={{ marginBottom: 10 }}>
                            <Label htmlFor="timeSpent">Time Spent:</Label>
                            <NumberBox name="timeSpent" inputId="timeSpent" value={this.state.editTimesheet.timeSpent} style={{ width: "220px" }} spinners={false}></NumberBox>
                            <div className="error">{this.getError('timeSpent')}</div>
                        </div>
                    </Form>
                </div>
                <div className="dialog-button">
                    <LinkButton style={{ width: 80 }} onClick={() => this.draftRow()}>Draft</LinkButton>
                    <LinkButton style={{ width: 80 }} onClick={() => this.setState({ closed2: false })}>Submit</LinkButton>
                    <LinkButton style={{ width: 80 }} onClick={() => this.setState({ closed: true })}>Close</LinkButton>
                </div>
            </Dialog>
        )
    }

    renderDialog2() {
        const row = this.state.model;
        const { title, closed2, rules } = this.state;
        return (
            <Dialog modal title="Submit" closed={closed2} onClose={() => this.setState({ closed: true, btn: null })}>
                <div className="f-full" style={{ padding: '20px 50px' }}>
                    <Form className="f-full"
                        ref={ref => this.form = ref}
                        model={row}
                    // rules={rules}
                    // onValidate={(errors) => this.setState({ errors: errors })}
                    // onChange={(e)=>this.handeleChange()}
                    >
                        <div style={{ marginBottom: 10 }}>
                            <h6>Are you sure you want to submit this timesheet?
                                <br></br>Once submitted, you won't be able to edit this timesheet.</h6>


                            {/* <div className="error">{this.getError('comments')}</div> */}
                        </div>
                    </Form>
                </div>
                <div className="dialog-button">
                    <LinkButton className="btn btn-primary" style={{ width: "80px", height: "35px", padding: "2px" }} onClick={() => this.submitRow()}>Yes</LinkButton>
                    <LinkButton className="btn btn-danger" style={{ width: "80px", height: "35px", padding: "2px" }} onClick={() => this.setState({ closed2: true })}>No</LinkButton>
                </div>
            </Dialog>
        )
    }

    editRow = () => {
        const { selected } = this.props
        let temp = Object.assign({}, selected)
        this.props.projectList.map(project => {
            if (project.name === temp.projectId) {
                temp.projectId = project.id
            }
        })
        this.props.subprojectList.map(subproject => {
            if (subproject.name === temp.subprojectId) {
                temp.subprojectId = subproject.id
            }
        })
        this.setState({
            closed: false,
            editTimesheet: {
                id: selected.id,
                projectId: temp.projectId,
                subprojectId: temp.subprojectId,
                description: selected.description,
                enabled: true,
                userId: this.props.userId,
                timeSpent: temp.timeSpent.split("H")[0],
                status: selected.status,
                comments: " ",
                dateBs: new Date(selected.dateBs)
            }
        })
    }



    render() {
        const { total, pageNumber, pageSize } = this.state.pageOptions
        const { user, projectList, subprojectList, permissions } = this.props
        const { searchparam, isLoading, pageArray } = this.state
        const styles = { width: 110, height: 30 };

        return <div>
            <Panel
                title='Timesheet View'
                bodyStyle={{ padding: 0 }}
                style={{ height: 533 }}>
                <Messager
                    ref={(ref) => (this.messager = ref)}
                    showHeader={false}
                    borderType='none'
                    content={({ title, msg, buttons, reload }) => (
                        <div className='alert-content'>
                            <h3>{title}</h3>
                            <div
                                style={{ marginBottom: 5 }}
                                dangerouslySetInnerHTML={{ __html: msg }}
                            ></div>
                            <div className='m-buttons'>
                                {buttons.map((button, index) => (
                                    <LinkButton
                                        key={index}
                                        text={button.text}
                                        onClick={() => {
                                            this.messager.close(button);
                                            if (reload) {
                                                window.location.reload();
                                            }
                                        }}
                                    />
                                ))}
                            </div>
                        </div>
                    )}
                />
                <div
                    className='loadingmodel'
                    style={{ display: isLoading ? "block" : "none" }}
                ></div>
                <DataGrid
                    data={pageArray}
                    style={{ height: 500 }}
                    selectionMode='single'

                    pagination
                    {...this.state.pageOptions}
                    {...this.props.selected}
                    onSelectionChange={(selection) =>
                        this.props.onSelectionChange(selection)
                    }
                    // onPageChange={this.onPageChange}

                    toolbar={({ editingItem }) => (
                        <div style={{ padding: 4 }}>

                            <b>From date:</b>&nbsp;
                            <DateBox
                                style={{ width: "160px", marginRight: "5px" }}
                                format="yyyy-MM-dd"
                                value={searchparam.fromdate}
                                onChange={(e) => this.searchFieldOnChange("fromdate", e)}
                            ></DateBox>
                            <b>To date:</b>&nbsp;
                            <DateBox
                                style={{ width: "160px", marginRight: "5px" }}
                                format="yyyy-MM-dd"
                                value={searchparam.todate}
                                onChange={(e) => this.searchFieldOnChange("todate", e)}
                            ></DateBox>

                            <b>Project:</b>&nbsp;
                            <ComboBox
                                style={{ width: "130px", marginRight: "5px" }}
                                data={projectList}
                                valueField='id'
                                textField='name'
                                value={searchparam.projectId}
                                editable={false}
                                onChange={(e) => this.searchFieldOnChange("projectId", e)}
                            ></ComboBox>
                            &nbsp;

                            <b>SubProject:</b>&nbsp;
                            <ComboBox
                                style={{ width: "130px", marginRight: "5px" }}
                                data={subprojectList}
                                valueField='id'
                                textField='name'
                                value={searchparam.subprojectId}
                                editable={false}
                                onChange={(e) => this.searchFieldOnChange("subprojectId", e)}
                            ></ComboBox>
                            &nbsp;

                            <b>Status:</b>&nbsp;
                            <ComboBox
                                style={{ width: "100px", marginRight: "5px" }}
                                data={this.state.statusData}
                                value={searchparam.status}
                                editable={false}
                                onChange={(e) => this.searchFieldOnChange("status", e)}
                            ></ComboBox>
                            &nbsp;
                            <LinkButton
                                style={{ marginRight: "5px" }}
                                iconCls="icon-search"
                                plain
                                onClick={this.getData}

                            >
                                Search
                            </LinkButton>

                            {permissions.includes(
                                "timesheet-edit"
                            ) ? (
                                <LinkButton
                                    iconCls='icon-edit'

                                    disabled={isEmpty(this.props.selected)}
                                    onClick={(this.editRow)}
                                >
                                    Edit
                                </LinkButton>
                            ) : (
                                ""
                            )}

                        </div>
                    )}>


                    <GridColumn width={80} field="dateBs" title="Date"></GridColumn>
                    <GridColumn width={120} field="projectId" title="Project"></GridColumn>
                    <GridColumn width={150} field="subprojectId" title="Sub-Project"></GridColumn>
                    <GridColumn width={220} field="description" title="Description"
                        header={() => <span>Description</span>}
                        render={({ row }) => (
                            <div title={row.description}>{row.description}</div>
                        )}
                    ></GridColumn>
                    <GridColumn width={80} field="timeSpent" title="Timespent"></GridColumn>
                    <GridColumn width={130} field="comments" title="Comments"
                        header={() => <span>Comments</span>}
                        render={({ row }) => (
                            <div title={row.comments}>{row.comments}</div>
                        )}
                    ></GridColumn>
                    <GridColumn width={80} field="status" title="Status"
                        header={() => <span>Status</span>}
                        render={({ row }) => (
                            <div>
                                {(row.status) === "Submitted" ? (
                                    <div className='rounded' style={{ backgroundColor: "#6c757d", color: "white", padding: '8px 8px', textAlign: "center" }}>
                                        <div>{row.status}</div>
                                    </div>
                                ) : ""}
                                {(row.status) === "Approved" ? (
                                    <div className='rounded' style={{ backgroundColor: "#28a745", color: "white", padding: '8px 8px', textAlign: "center" }}>
                                        <div>{row.status}</div>
                                    </div>
                                ) : ""}
                                {(row.status) === "Rejected" ? (
                                    <div className='rounded' style={{ backgroundColor: "#dc3545", color: "white", padding: '8px 8px', textAlign: "center" }}>
                                        <div>{row.status}</div>
                                    </div>
                                ) : ""}
                                {(row.status) === "Draft" ? (
                                    <div className='rounded' style={{ backgroundColor: "#007bff", color: "white", padding: '8px 8px', textAlign: "center" }}>
                                        <div>{row.status}</div>
                                    </div>
                                ) : ""}
                            </div>
                        )}

                    ></GridColumn>


                </DataGrid>
                {this.renderDialog()}
                {this.renderDialog2()}
            </Panel>
        </div>;
    }
}


